import { render, staticRenderFns } from "./addSegmentBase.vue?vue&type=template&id=bed55d1c&"
import script from "./addSegmentBase.vue?vue&type=script&lang=js&"
export * from "./addSegmentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports